import fetchWebApi from 'api/fetchWebApi';

const postFdfConfirmationApiCall = async (): Promise<void> => {
  fetchWebApi('/client/application/fdf-confirmation', undefined, {
    method: 'post',
  });
};

export default postFdfConfirmationApiCall;
